// PictureForm.js
import React, { useState } from "react";
import { Modal, Button, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  createPicture,
  updatePicture,
  deletePicture,
} from "../../services/housingService";
import { toast } from "react-toastify";
import { useDropzone } from "react-dropzone";
import { compressImage } from "../../utils/image-compression-and-integration";
import ShowPic from "../showPic/ShowPic";

const PictureForm = ({
  show,
  onClose,
  pictures,
  setPictures,
  housingId,
  pendingPhotos,
  setPendingPhotos,
  isMobile,
}) => {
  
  const [previewSrc, setPreviewSrc] = useState(null);
  
  // Drag & Drop area
  const DropzoneArea = () => {
    const onDrop = async (acceptedFiles) => {
      const newFiles = [];
      for (const file of acceptedFiles) {
        try {
          const compressed = await compressImage(file, {
            maxSizeMB: 0.4,
            maxWidth: 1160,
            maxHeight: 1160,
          });
          newFiles.push({
            file: compressed,
            preview: URL.createObjectURL(compressed),
            description: "",
            progress: 0,
          });
        } catch (err) {
          newFiles.push({
            file,
            preview: URL.createObjectURL(file),
            description: "",
            progress: 0,
          });
        }
      }
      setPendingPhotos((prev) => [...prev, ...newFiles]);
    };

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
      onDrop,
    });
    if (isMobile) {
      return (
        <div
          {...getRootProps()}
          className="border rounded p-4 mb-3 text-center"
          style={{
            background: isDragActive ? "#f0f0f0" : "#fafafa",
            cursor: "pointer",
          }}
        >
          <input {...getInputProps()} />
          <p>Klik untuk pilih file</p>
        </div>
      );
    } else {
      return (
        <div
          {...getRootProps()}
          className="border rounded p-4 mb-3 text-center"
          style={{
            background: isDragActive ? "#f0f0f0" : "#fafafa",
            cursor: "pointer",
          }}
        >
          <input {...getInputProps()} />
          {isDragActive ? (
            <p>Lepaskan file di sini...</p>
          ) : (
            <p>Tarik & jatuhkan foto di sini, atau klik untuk pilih file</p>
          )}
        </div>
      );
    }
  };

  return (
    <>
      <Modal
        show={show}
        onHide={() => {
          setPendingPhotos([]);
          onClose();
        }}
        onExit={() => setPendingPhotos([])}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Foto Rumah</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Upload foto tambahan */}
          {/* {isMobile ? (
          <Form.Group className="mb-3">
            <Form.Label>Tambah Foto Baru</Form.Label>
            <Form.Control
              type="file"
              accept="image/*"
              multiple
              onChange={async (e) => {
                const files = Array.from(e.target.files);
                const newFiles = [];
                for (const file of files) {
                  try {
                    const compressed = await compressImage(file, {
                      maxSizeMB: 1,
                      maxWidth: 1600,
                      maxHeight: 1600,
                    });
                    newFiles.push({
                      file: compressed,
                      preview: URL.createObjectURL(compressed),
                      description: "",
                      progress: 0,
                    });
                  } catch {
                    newFiles.push({
                      file,
                      preview: URL.createObjectURL(file),
                      description: "",
                      progress: 0,
                    });
                  }
                }
                setPendingPhotos((prev) => [...prev, ...newFiles]);
              }}
            />
          </Form.Group>
        ) : ( */}
          <DropzoneArea />
          {/* )} */}

          {/* Preview foto baru */}
          {pendingPhotos.length > 0 && (
            <div className="mb-3">
              <h6>Foto Baru (belum disimpan)</h6>
              <div className="d-flex flex-wrap gap-3">
                {pendingPhotos.map((p, idx) => (
                  <div
                    key={idx}
                    className="border rounded p-2 position-relative"
                    style={{ width: "180px" }}
                  >
                    <img
                      src={p.preview}
                      alt={`new-${idx}`}
                      className="mb-2"
                      style={{
                        width: "100%",
                        height: "120px",
                        objectFit: "cover",
                      }}
                      onClick={() => setPreviewSrc(p.preview)}
                    />
                    <Form.Control
                      type="text"
                      size="sm"
                      placeholder="Deskripsi foto"
                      value={p.description}
                      onChange={(e) => {
                        const newDesc = e.target.value;
                        setPendingPhotos((prev) =>
                          prev.map((item, i) =>
                            i === idx ? { ...item, description: newDesc } : item
                          )
                        );
                      }}
                    />
                    {/* Tombol hapus sebelum upload */}
                    <Button
                      size="sm"
                      variant="danger"
                      className="position-absolute top-0 start-0 m-2 px-2 py-1"
                      onClick={() => {
                        setPendingPhotos((prev) =>
                          prev.filter((_, i) => i !== idx)
                        );
                        URL.revokeObjectURL(p.preview);
                      }}
                    >
                      ✕
                    </Button>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* {/* Daftar foto lama */}
          {/* <div className="d-flex flex-wrap gap-3">
          {pictures.map((pic) => ( */}
          <div className="d-flex flex-wrap gap-3">
            {pictures.length > 0 ? (
              pictures.map((pic) => (
                <div
                  key={pic.id}
                  className="border rounded p-2 position-relative"
                  style={{ width: "180px" }}
                >
                  <div
                    style={{
                      width: "100%",
                      height: "150px",
                      overflow: "hidden",
                      borderRadius: "6px",
                      marginBottom: "8px",
                    }}
                  >
                    <img
                      src={pic.blobUrl}
                      // src={pic.blobUrl || pic.url || ""}
                      alt={`foto-${pic.id}`}
                      className={'housingdata-foto'}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover", // ✅ gambar selalu rapi
                      }}
                      onClick={() => setPreviewSrc(pic.blobUrl)}
                      // onLoad={async (e) => {
                      //   if (!pic.blobUrl && pic.file_name) {
                      //     try {
                      //       const blob = await getHousingPhoto(pic.file_name);
                      //       setPictures((prev) =>
                      //         prev.map((p) =>
                      //           p.id === pic.id ? { ...p, blobUrl: blob } : p
                      //         )
                      //       );
                      //     } catch (err) {
                      //       console.error("Gagal ambil blob foto:", err);
                      //     }
                      //   }
                      // }}
                    />
                  </div>
                  <Form.Control
                    as="textarea"
                    size="sm"
                    style={{
                      fontSize: "0.85rem",
                      whiteSpace: "pre-wrap", // line break kebaca
                      wordWrap: "break-word", // wrap kata panjang
                      overflow: "hidden", // ✅ ilangin scrollbar
                      resize: "none", // ✅ user nggak bisa tarik2 resize
                    }}
                    defaultValue={pic.description || ""}
                    onBlur={async (e) => {
                      const newDesc = e.target.value;
                      if (newDesc !== (pic.description || "")) {
                        // ✅ hanya update kalau berubah
                        try {
                          const fd = new FormData();
                          fd.append("description", newDesc);
                          const res = await updatePicture(pic.id, fd);
                          setPictures((prev) =>
                            prev.map((p) =>
                              p.id === pic.id
                                ? { ...p, description: res.data.description }
                                : p
                            )
                          );
                          toast.success("Deskripsi diperbarui");
                        } catch {
                          toast.error("Gagal update deskripsi");
                        }
                      }
                    }}
                  />
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id={`tooltip-foto-${pic.id}`}>Hapus</Tooltip>
                    }
                  >
                    <Button
                      size="sm"
                      variant="danger"
                      className="position-absolute top-0 start-0 m-2 px-2 py-1"
                      onClick={async () => {
                        try {
                          await deletePicture(pic.id);
                          setPictures((prev) =>
                            prev.filter((p) => p.id !== pic.id)
                          );
                          toast.success("Foto dihapus");
                        } catch {
                          toast.error("Gagal hapus foto");
                        }
                      }}
                    >
                      ✕
                    </Button>
                  </OverlayTrigger>
                </div>
                //   ))}
                // </div>
              ))
            ) : (
              <p className="text-muted">
                Belum ada foto untuk rumah ini. Tambahkan foto baru di atas.
              </p>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          {pendingPhotos.length > 0 && (
            <Button
              variant="success"
              onClick={async () => {
                try {
                  await Promise.all(
                    pendingPhotos.map(async (p, idx) => {
                      const fd = new FormData();
                      fd.append("photo", p.file);
                      fd.append("description", p.description);
                      const res = await createPicture(
                        housingId,
                        fd,
                        (event) => {
                          const percent = Math.round(
                            (event.loaded * 100) / event.total
                          );
                          setPendingPhotos((prev) =>
                            prev.map((item, i) =>
                              i === idx ? { ...item, progress: percent } : item
                            )
                          );
                        }
                      );
                      setPictures((prev) => [...prev, res.data]);
                      toast.success(`Foto ${p.file.name} berhasil diupload`);
                    })
                  );
                  setPendingPhotos([]);
                  onClose();
                } catch (err) {
                  toast.error("Beberapa foto gagal diupload ❌");
                }
              }}
            >
              Simpan & Tutup
            </Button>
          )}
          <Button
            variant="secondary"
            onClick={() => {
              setPendingPhotos([]);
              onClose();
            }}
          >
            Batal
          </Button>
        </Modal.Footer>
      </Modal>
      {previewSrc && (
        <ShowPic
          src={previewSrc}
          alt="Preview Foto"
          onClose={() => setPreviewSrc(null)}
        />
      )}
    </>
  );
};

export default PictureForm;
